namespace TabAurous.Retail {
    export interface ReceiptForm {
        VoucherTypeId: Serenity.IntegerEditor;
        TransId: Serenity.StringEditor;
        Date: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        IsAdvance: Serenity.BooleanEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        ReceiptDetails: ReceiptDetailsEditor;
        PartyBalance: Finance.PartyBalanceEditor;
        KnockOffTotal: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
        EnteredBy: Serenity.StringEditor;
    }

    export class ReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.Receipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptForm.init)  {
                ReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;
                var w6 = ReceiptDetailsEditor;
                var w7 = Finance.PartyBalanceEditor;
                var w8 = s.DecimalEditor;

                Q.initFormType(ReceiptForm, [
                    'VoucherTypeId', w0,
                    'TransId', w1,
                    'Date', w2,
                    'VoucherNo', w1,
                    'POSCustomerId', w3,
                    'IsAdvance', w4,
                    'RefNo', w1,
                    'RefDate', w2,
                    'CurrencyId', w5,
                    'UserId', w5,
                    'ReceiptDetails', w6,
                    'PartyBalance', w7,
                    'KnockOffTotal', w8,
                    'TotalAmount', w8,
                    'Narration', w1,
                    'EnteredBy', w1
                ]);
            }
        }
    }
}
